import { EMPRESAS } from "./ActionTypes";

export const getEmpresa = (empresa, imagemLogo, fantasia) => ({
  type: EMPRESAS,
  loading: true,
  empresa,
  imagemLogo,
  fantasia
});
